module.exports = __webpack_public_path__ + "img/V59.27a7a835.jpg";